<template>
  <div
    class="fixed inset-0 z-50 flex items-center justify-center bg-black/50 p-4"
    @keydown.esc="close"
  >
    <div
      ref="modal"
      class="relative w-full max-w-lg rounded-xl bg-white p-6 shadow-xl max-h-[80svh] overflow-y-auto space-y-4"
    >
      <button
        class="absolute top-2 right-2 bg-transparent text-gray-900"
        @click="close"
      >
        <Xmark class="w-5" />
      </button>
      <slot name="header"> </slot>

      <slot name="body"> </slot>

      <slot name="footer">
        <div class="flex justify-end">
          <button @click="close">Close</button>
        </div>
      </slot>
    </div>
  </div>
</template>

<script setup>
import { onClickOutside } from "@vueuse/core";
import { onMounted, onUnmounted, ref } from "vue";
import Xmark from "@/components/icons/Xmark.vue";

const emit = defineEmits(["update:range"]);
const modal = ref(null);

function close() {
  emit("close");
}

onClickOutside(modal, () => {
  close();
});

function handleKeyDown(e) {
  if (e.key === "Escape") {
    close();
  }
}

onMounted(() => {
  document.addEventListener("keydown", handleKeyDown);
});

onUnmounted(() => {
  document.removeEventListener("keydown", handleKeyDown);
});
</script>
